import script from "./SendTestSms.vue?vue&type=script&name=SendTestSms&setup=true&lang=ts"
export * from "./SendTestSms.vue?vue&type=script&name=SendTestSms&setup=true&lang=ts"

const __exports__ = script;

export default __exports__